import type { FC } from 'react';
import { SubmitHandler } from 'react-hook-form';
import { useHistory } from 'react-router-dom';

import { StepProps } from 'components/Stepper/types';
import type {
  EditableRole,
  MemberInformationRoleFormSchema,
} from 'features/Team/components/MemberInformationRoleForm/schema';
import { MemberRoleLayout } from 'features/Team/components/MemberRoleLayout';

import * as routes from '../../../../../../../../routes';
import { useMemberRoleTransitionState } from '../../../MemberRoleTransitionProvider';
import locales from './locales';

export const MemberRole: FC<StepProps> = ({ goNext }) => {
  const history = useHistory();

  const { dispatch, identity, isFreeRolesOnly, memberRole, transitions } =
    useMemberRoleTransitionState();

  const cancelFlow = () => {
    history.push(routes.members);
  };

  const handleChange = async (role: EditableRole) => {
    dispatch({
      payload: {
        role,
      },
      type: 'SUBMIT_ROLE',
    });
  };

  const handleSubmit: SubmitHandler<
    MemberInformationRoleFormSchema
  > = async () => {
    goNext();
  };

  if (!transitions) {
    return null;
  }

  return (
    <MemberRoleLayout
      applyLabel={locales.submit}
      initialRole={identity?.role}
      isFreeRolesOnly={isFreeRolesOnly}
      onApplyClicked={handleSubmit}
      onBackClicked={cancelFlow}
      onCancelClicked={cancelFlow}
      onRoleChanged={handleChange}
      roleTransitions={transitions}
      selectedRole={memberRole.role}
      showFreeRolesTag={false}
      title={locales.formatString(locales.title, {
        firstName: identity?.firstName ?? '',
        lastName: identity?.lastName ?? '',
      })}
    />
  );
};
